export default __webpack_public_path__ + "static/media/location.30b75773.svg";